import { getCurrentSeason } from '../data/seasons';

export const createMatchGroupId = (seasonId) => {
  const safeSeason = seasonId || getCurrentSeason();
  const epochSeconds = Math.floor(Date.now() / 1000);
  const randomLength = 3 + Math.floor(Math.random() * 3);
  let randomSeed = Math.random().toString(36).slice(2);
  while (randomSeed.length < randomLength) {
    randomSeed += Math.random().toString(36).slice(2);
  }
  const suffix = randomSeed.slice(0, randomLength);
  return `match_${safeSeason}_${epochSeconds}_${suffix}`;
};
